import React, {Component} from 'react';

class CounterStatic extends Component {

	componentDidMount() {
		let { hours, minutes, seconds } = this.props;
		if (hours === undefined)
			hours = 0;

		if (minutes === undefined)
			minutes = 0;

		if (minutes === 0)
			minutes='00'

		if (seconds === 0)
			seconds='00'			
	}	

	render() {
		const { hours, minutes, seconds } = this.props;

		return (
			<div className="counter">
				{hours !== undefined && (
					<div className="counter-item">
						<span className="counter-digits">{hours}</span>
						<span className="counter-unit">h</span>
					</div>
				)}
				{minutes !== undefined && (
					<div className="counter-item">
						<span className="counter-digits">{minutes}</span>
						<span className="counter-unit">m</span>
					</div>
				)}
				{seconds !== undefined && seconds !== null && (
					<div className="counter-item counter-seconds">
						<span className="counter-digits">{seconds}</span>
						<span className="counter-unit">s</span>
					</div>
				)}
			</div>
		);
	}
}

export default CounterStatic;
